import Icon from './Icon';

export * from './Icon.enums';
export * from './Icon.types';
export default Icon;
